import { GetFacturationRulesResponse } from "@/app/api/facturation-rules/route";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";
import { getFacturationRulesRequestSchema } from "@/lib/schemas/facturation-rules";

const FACTURATION_RULES_ENDPOINT = "/api/facturation-rules";

export const invalidateFacturationRulesQuery = createInvalidateQuery(
  FACTURATION_RULES_ENDPOINT,
);

export const useFacturationRulesQuery =
  createQueryHook<GetFacturationRulesResponse>(
    FACTURATION_RULES_ENDPOINT,
    getFacturationRulesRequestSchema,
  );
